import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SmartSearchAgentTemplateComponent } from './base-template/smart-search-agent-template.component';
import { SmartSearchBaseTemplateComponent } from './base-template/smart-search-base-template.component';
import { SmartSearchPlanStatusTemplateComponent } from './base-template/smart-search-plan-status-template.component';
import { SmartSearchBackupStatusTemplateComponent } from './custom-templates/smart-search-backup-status-template.component';
import { SmartSearchCompaniesTemplateComponent } from './custom-templates/smart-search-companies-template.component';
import { SmartSearchComputerNameTemplateComponent } from './custom-templates/smart-search-computer-template.component';
import { SmartSearchIPTemplateComponent } from './custom-templates/smart-search-ip-template.component';
import { SmartSearchLastLoginTemplateComponent } from './custom-templates/smart-search-last-login-template.component';
import { SmartSearchLicenseTypesTemplateComponent } from './custom-templates/smart-search-license-types-template.component';
import { SmartSearchOsTemplateComponent } from './custom-templates/smart-search-os-template.component';
import { SmartSearchProductInstalledTemplateComponent } from './custom-templates/smart-search-product-installed-template.component';
import { SmartSearchProductNotInstalledTemplateComponent } from './custom-templates/smart-search-product-not-installed-template.component';
import { SmartSearchRestoreStatusTemplateComponent } from './custom-templates/smart-search-restore-status-template.component';
import { SmartSearchStatusTemplateComponent } from './custom-templates/smart-search-status-template.component';
import { SmartSearchTagsTemplateComponent } from './custom-templates/smart-search-tags-template.component';

const templates = [
  SmartSearchBaseTemplateComponent,
  SmartSearchCompaniesTemplateComponent,
  SmartSearchOsTemplateComponent,
  SmartSearchStatusTemplateComponent,
  SmartSearchPlanStatusTemplateComponent,
  SmartSearchBackupStatusTemplateComponent,
  SmartSearchRestoreStatusTemplateComponent,
  SmartSearchIPTemplateComponent,
  SmartSearchAgentTemplateComponent,
  SmartSearchProductInstalledTemplateComponent,
  SmartSearchProductNotInstalledTemplateComponent,
  SmartSearchTagsTemplateComponent,
  SmartSearchComputerNameTemplateComponent,
  SmartSearchLastLoginTemplateComponent,
  SmartSearchLicenseTypesTemplateComponent
];

@NgModule({
  exports: templates,
  imports: [CommonModule, ...templates]
})
export class SmartSearchTemplatesModule {}
